module.exports = __webpack_public_path__ + "img/c08_unittechelephantarcherchampion_Normal_ua.b8cc9e36.webp";